import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade , Thumbs } from 'swiper/modules';
import 'swiper/css/bundle';
import AOS from 'aos';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs]);
window.Swiper = Swiper;

// JavaScript
$(document).ready( function () {
  AOS.init();

  //scroll top
  $('.back-to-top').click(function(event){
    $("html,body").animate({scrollTop: 0}, 1000);
  });

  function headerScroll() {
    if ($(window).scrollTop() > 200) {
      $('.back-to-top').show();
    } else {
      $('.back-to-top').hide();
    }
  }

  headerScroll();
  $(window).on('scroll', function () {
    headerScroll();
  });

  $('.header-mobile-menu').on('click', function () {
    $(this).toggleClass('active');
    $('.header-menu-outer').toggleClass('active');
  });

  $('.dropdown .menu-link').click(function (e) {
    if (window.innerWidth <= 1024) {
      e.preventDefault();
      if ($(this).parent('.header-menu-link').hasClass('active')) {
        $(this).parent('.header-menu-link').removeClass('active');
      } else {
        $(this).parent('.header-menu-link').addClass('active');
      }
    }
  });

  var indexBanner = new Swiper('#indexBanner', {
    effect: 'fade',
    autoplay: {
      delay: 5000,
    },
    loop: true,
    peed: 1000,
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
  });

  var indexProductServices = new Swiper('#indexProductServices', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 10,
    navigation: {
      prevEl: ".indexPS-prev",
      nextEl: ".indexPS-next",
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      600: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      900: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1441: {
        slidesPerView: 3,
        spaceBetween: 46,
      },
    },
  });

  // dropdown
  $('.dropdown-btn').on('click', function () {
    const id = $(this).attr('id');
    const dropdown_is_active = $('[aria-labelledby=' + id + ']').hasClass("is-active");
    if (dropdown_is_active >= 1) {
      $('[aria-labelledby=' + id + ']').removeClass('is-active');
      if (window.innerWidth <= 640) {
        $('body').css({
          'height': '',
          'overflow': '',
        })
      }
    } else {
      $(".dropdown-list:not([aria-labelledby=" + id + "]").removeClass('is-active');
      $('[aria-labelledby=' + id + ']').addClass('is-active');
      if (window.innerWidth <= 640) {
        $('body').css({
          'height': '100vh',
          'overflow': 'hidden',
        })
      }
    }
  });

  $(document).click(function (event) {
    if (!$(event.target).closest('.dropdown-btn').length) {
      if ($('.dropdown-list').is(":visible")) {
        $(".dropdown-list").removeClass('is-active');
        if (window.innerWidth <= 640) {
          $('body').css({
            'height': '',
            'overflow': '',
          })
        }
      }
    }
  });

  // index
  if ($(".wrap").attr('data-page') == 'home') {
    $(window).on("scroll", function () {
      let scrollTop = $(window).scrollTop();
      let indexCould = $("#indexCloud").offset().top;
      let indexJoin = $("#indexJoin").offset().top;
      let windowHeight = $(window).height();

      let start = indexCould - windowHeight - $("#indexCloud").height();
      let end = indexJoin - windowHeight / 3;

      if (scrollTop > start && scrollTop < end) {
        let progress = (scrollTop - start) / (end - start);
        let opacity = progress;
        let translateX1 = -60 * progress;
        let translateX2 = 60 * progress;
        let translateY = -60 * progress;
        let join_translateY = (progress * 20) - 20;

        $(".index-esg-linear").css({
          transform: `scaleY(${progress}) translateY(${-progress * 10}vw)`,
        });
        $(".could-1").css({
          transform: `translate(${translateX1}%, ${translateY}%)`,
          opacity: opacity
        });
        $(".could-2").css({
          transform: `translate(${translateX2}%, ${translateY}%)`,
          opacity: opacity
        });
        $("#indexJoin").css({
          transform: `translateY(${join_translateY}%)`,
        });
      }else {
        $("#indexJoin").css({
          transform: `translateY(0%)`,
        });
      }
    });
  }

  // milestone
  function adjustMilestoneHeight() {
    let totalHeight = 0;
    $('.milestone-item:not(.hide-milestone)').each(function () {
      totalHeight += $(this).outerHeight(true);
    });

    $('.milestone-items').css('min-height', totalHeight + 'px');
  }
  let milestoneItems = $('.milestone-item');
  if (milestoneItems.length > 10) {
    $('#btn-milestone-view').show();
    milestoneItems.slice(10).addClass('hide-milestone');
  }

  adjustMilestoneHeight();

  $('#btn-milestone-view').click(function () {
    let hiddenItems = $('.milestone-item').slice(10);
    hiddenItems.removeClass('hide-milestone');
    $(this).hide();
    adjustMilestoneHeight();
  });

  // footprint
  $(".footprint-map-btn.factory").on("click", function () {
    const targetId = $(this).data("anchor");
    const headerHeight = $("#header").outerHeight();

    if (targetId && $(targetId).length) {
      $("html, body").animate({
        scrollTop: $(targetId).offset().top - headerHeight - 28
      }, 500);
    }
  });


  // 新聞中心 dropdown
  const dropdownNewsBtn = $('#dropdownNewsCate .dropdown-btn');
  const dropdownNewsItem = $('#dropdownNewsCate .dropdown-list .dropdown-item');

  dropdownNewsBtn.on('click', function(){
    $(this).closest('.dropdown-news-cate').toggleClass('is-active');
  })
  // 填入所選消息分類名稱
  dropdownNewsItem.on('click', function(){
    const selectedCate = $(this).text();

    $('.dropdown-btn').contents().filter(function(){
      return this.nodeType === 3;
    }).first().replaceWith(selectedCate);

    if($(this).closest('.dropdown-news-cate').hasClass('is-active')) {
      $(this).closest('.dropdown-news-cate').removeClass('is-active');
    }
  });
  // 點擊空白處關閉選單
  $(document).on('click', function(e){
    if(!$('.dropdown-news-cate').is(e.target) && $('.dropdown-news-cate').has(e.target).length === 0) {
      $('.dropdown-news-cate').removeClass('is-active');
    }
  });

  var publishYearTabs = new Swiper(".publish-year-tabs", {
    slidesPerView: 3,
    freeMode: true,
    spaceBetween: 16,
    navigation: {
      nextEl: ".news-filter-row .swiper-btn-ab .swiper-button-next",
      prevEl: ".news-filter-row .swiper-btn-ab .swiper-button-prev",
    },
    breakpoints: {
      480: {
        slidesPerView: 5,
      },
      640: {
        slidesPerView: 6,
      },
      1024: {
        slidesPerView: 7,
      },
    }
  });

  // ESG 績效頁－績效數據輪播
  const esgPerformanceSwiper = new Swiper("#esgPerformance", {
    slidesPerView: 1,
    spaceBetween: 2,
    autoplay: false,
    loop: true,
    navigation: {
      nextEl: ".esg-performance .esg-swiper-button-next",
      prevEl: ".esg-performance .esg-swiper-button-prev",
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
      1360: {
        slidesPerView: 4,
      },
    }
  });

  // ESG績效頁－績效數字載入計數器
  const startNum = 0;
  const duration = 1200; // 動畫時間 (1.5秒)
  const intervalTime = 12; // 更新間隔時間 (15ms)

  $('.esg-performance-card .num').each(function(index){
    let targetNum = parseFloat($(this).text().trim());

    if (!isNaN(targetNum)) {
      $(this).text(startNum); // 初始化數字

      // 數字歸零
      $(this).text(startNum);

      let currentNum = startNum;
      let steps = duration / intervalTime; // 總共要更新幾次
      let increment = targetNum / steps; // 計算每次增加的數值

      let interval = setInterval(() => {
        currentNum += increment;
        if (currentNum >= targetNum) {
          $(this).text(targetNum.toFixed(1)); // 最後確保數字正確
          clearInterval(interval);
        } else {
          $(this).text(Math.floor(currentNum)); // 顯示遞增的整數
        }
      }, intervalTime); // 控制數字變化速度
    }
  });

  // 自訂頁面 sidemenu toggle 顯示
  const sidemenuBtn = $('#sidemenuBtn');
  const sideMenu = $('#sideMenu');

  function handleSideMenuVisibility() {
    if (window.innerWidth < 640) {
      sideMenu.addClass('hidden');
    } else {
      sideMenu.removeClass('hidden');
    }
  }
  handleSideMenuVisibility();
  $(window).on('resize', function () {
    handleSideMenuVisibility();
  });

  sidemenuBtn.on('click', function(){
    sideMenu.toggleClass('hidden');
  })

  // 自訂頁面 sidemenu 第二層收合
  const sidemenuLinks = $('.sidemenu-link-group .link-title');
  const sidemenuSubLinks = $('.sidemenu-sub-links');

  sidemenuLinks.on('click', function(){
    $(this).toggleClass('active');
    $(this).closest('.sidemenu-link-group').children('.sidemenu-sub-links').toggleClass('hidden');
  });

  // 產品內頁 - 輪播圖
  var productSwiperThumb = new Swiper("#productBannerThumb", {
    loop: false,
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
  });
  var productSwiper = new Swiper("#productBanner", {
    loop: false,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-custom.swiper-button-next-custom",
      prevEl: ".swiper-button-custom.swiper-button-prev-custom",
    },
    thumbs: {
      swiper: productSwiperThumb,
    },
  });

  // 投資人模板收合
  if ($('.tinymce').length > 0) {
    $('.tinymce .ck-member-box details, .tinymce .ck-detail-min details').attr('open', true);
  } else {
    $('.ck-member-box details, .ck-detail-min details').removeAttr('open');
  }

  // accordion
  $('.accordion-item .accordion-title-group').click(function(){
    $(this).parent('.accordion-item').toggleClass('active').siblings().removeClass('active').find('.accordion-content').slideUp(200);
    $(this).siblings('.accordion-content').slideToggle(200);
  });

  // editor tabs
  $('.ck-tab-group').each(function() {
    var $group = $(this);
    var $tabs = $group.find('.ck-tab-items .ck-tab');
    var $contents = $group.find('.ck-tab-contents .tab-content');

    $tabs.first().addClass('active');
    $contents.first().show();

    $tabs.on('click', function(e) {
      e.preventDefault();

      var targetId = $(this).attr('href').replace('#', '');
      $(this).closest('.ck-tab-group').find('.tab-content').hide();
      $('#' + targetId).fadeIn();
      $tabs.removeClass('active');
      $(this).addClass('active');
    });
  });

  // search
  $('#search_btn').on('click', function() {
    $('#search_popup').addClass('is-active');
  })
  $('.search-popup-close, .search-popup-mask').on('click', function() {
    $('#search_popup').removeClass('is-active');
  })

  // search tab
  $('.tab[data-tab]').on('click', function () {
    var tabPanes = $(this).data('tabs');
    var ID = $(this).data('tab');
    $(this).addClass('is-active').siblings().removeClass('is-active');
    $("[data-tab-panes=" + tabPanes + "]").find("[data-tab-pane=" + ID + "]").addClass('is-active').siblings().removeClass('is-active');
  });

  const clearButton = document.getElementById("clear-button");
  const searchInput = document.getElementById("keyword");

  clearButton.addEventListener("click", function () {
    searchInput.value = "";
    searchInput.focus();
  });
});

